import * as plugins from './lele-pubapiclient.plugins';

export class PubapiClient {
  public async getBranches(): Promise<plugins.lointPubapi.IRequest_Any_Pubapi_GetCompanyBranches['response']['branches']> {
    const typedrequest = new plugins.typedrequest.TypedRequest<plugins.lointPubapi.IRequest_Any_Pubapi_GetCompanyBranches>(
      'https://pubapi.lossless.one/typedrequest',
      'getCompanyBranches'
    );
    const response = await typedrequest.fire({});
    return response.branches;
  }

  public async getProjects(): Promise<plugins.lointPubapi.IRequest_Any_Pubapi_GetProjects['response']['projects']> {
    const typedrequest = new plugins.typedrequest.TypedRequest<plugins.lointPubapi.IRequest_Any_Pubapi_GetProjects>(
      'https://pubapi.lossless.one/typedrequest',
      'getProjects'
    );
    const response = await typedrequest.fire({});
    return response.projects;
  }
}
